module.exports = __webpack_public_path__ + "static/media/r3s5.0ab55b3f.jpg";